import isValidURL from './isValidURL';
const considerOpenURL = (answer) => {
	isValidURL(answer) && confirm(`Mở ${answer}?`) && window.open(answer, '_blank');
};
export default considerOpenURL;
